<template>
  <div class="ListingLocation">
    <h5>{{'Location' | language}}</h5>
    <GmapMap
      :center="{
          lat:parseFloat(property.int_latitude),
          lng:parseFloat(property.int_longitude)
      }"
      :zoom="15"
      map-type-id="roadmap"
      v-bind:options="mapStyle"
      style="width: 100%; height: 300px"
    >
      <GmapMarker
        :position="{
          lat:parseFloat(property.int_latitude),
          lng:parseFloat(property.int_longitude)
        }"
        :clickable="false"
        :draggable="false"
        :icon="icon"
      />
    </GmapMap>
  </div>
</template>

<script>
  import config from '../../../config'

  export default {
    name: 'listing-location',

    data: function() {
      return {
        mapStyle: config.MAP_STYLE,
        icon: {
          url: 'https://i.ibb.co/9sMJ7mM/jhf-marker-list.png',
          // url:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQel5HmOI-VzORbKG0AbDCF7hHwgVH6ELlgkFVP1-52xe7dEQjVgw',
          size: {width: 30, height: 40, f: 'px', b: 'px'},
          scaledSize: {width: 30, height: 40, f: 'px', b: 'px'}
        },
      }
    },
    props: {
      property: Object
    },
    mapStyle: config.MAP_STYLE,
    icon: {
      url: 'https://i.ibb.co/sVqyJS2/jhf-marker-price.png',
      // url:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQel5HmOI-VzORbKG0AbDCF7hHwgVH6ELlgkFVP1-52xe7dEQjVgw',
      size: { width: 80, height: 30, f: 'px', b: 'px' },
      scaledSize: { width: 80, height: 30, f: 'px', b: 'px' }
    },
    components: {
    }
  }
</script>

<style lang="scss" scoped>
  .ListingLocation {
    display: inline-block;
    width: 100%;
  }
</style>

